import * as firebase from "firebase";
import _ from "lodash";
import { reset } from "redux-form";
import { dateToStringFormat } from "../utils/Utils";

export const FETCH_FIRST_SECTION = "fetch_first_section";
export const FETCH_FIRST_SECTION_SUCCESS = "fetch_first_section_sucess";
export const FETCH_FIRST_SECTION_FAIL = "fetch_first_section_fail";

export const UPDATE_FIRST_SECTION = "update_first_section";
export const UPDATE_FIRST_SECTION_SUCCESS = "update_first_section_sucess";
export const UPDATE_FIRST_SECTION_FAIL = "update_first_section_fail";

export function fetchFirstSection(callback) {
  console.log("fetchFirstSection");
  const sectionRef = firebase.database().ref("about");

  return (dispatch) => {
    dispatch({
      type: FETCH_FIRST_SECTION,
    });

    sectionRef.on("value", (snapshot) => {
      // const values = snapshot.val();

      if (snapshot.numChildren() > 0) {
        let section = {};
        snapshot.forEach((rawProduct) => {
          section[rawProduct.key] = {
            ...rawProduct.val(),
            id: rawProduct.key,
          };
        });
        if (callback) {
          callback(section);
        }

        dispatch({
          type: FETCH_FIRST_SECTION_SUCCESS,
          payload: section,
        });
      } else {
        console.log("No products in db!");
      }
    });
  };
}

export function updateFirstSection(data, finishCallback) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_FIRST_SECTION,
    });
    const id = Object.keys(data)[0];
    const image_paths = data[id].image_paths;
    // check if image was updated
    if (typeof image_paths.name === "string") {
      // upload image to storage
      performUpload(
        // upload image to storage
        {
          file: image_paths.originFileObj,
          uploadPath: "public/images/about",
          // namePrefix: dateToStringFormat() || "000000",
          id,
        },
        (progress) => {
          console.log("progressCallback:", progress);
        },
        (uploadFile) => {
          data[id].image_paths = uploadFile.url;
          writeSectionToDatabase(
            { section: data[id], dbAboutId: id },
            dispatch,
            finishCallback
          );
        }
      );
    } else {
      writeSectionToDatabase(
        { section: data[id], dbAboutId: id },
        dispatch,
        finishCallback
      );
    }
  };
}

function writeSectionToDatabase(
  { section, dbAboutId },
  // uploadedFiles,
  dispatch,
  callback
) {
  const aboutRef = firebase
    .database()
    .ref("about")
    .child(dbAboutId);

  aboutRef.update(section, (error) => {
    if (error) {
      dispatch({
        type: UPDATE_FIRST_SECTION_FAIL,
      });
      if (callback) {
        callback(error);
      }
    } else {
      dispatch({
        type: UPDATE_FIRST_SECTION_SUCCESS,
      });
      if (callback) {
        callback();
      }
    }
  });
}

// function uploadFiles(
//   { files, uploadPath, namePrefix, dbProductId },
//   progressCallback,
//   finishCallback
// ) {
//   // use select file from files
//   const nextFile = _.find(files, ["uploaded", false]);
//   if (nextFile) {
//     performUpload(
//       {
//         file: nextFile.file,
//         uploadPath,
//         namePrefix,
//         dbProductId,
//       },
//       (progress) => {
//         if (progressCallback) {
//           progressCallback(nextFile, progress);
//         }
//       },
//       ({ fileName, url }) => {
//         // mark this file as uploaded
//         nextFile.uploaded = true;
//         nextFile.uploadedURL = url;
//         nextFile.uploadedFileName = fileName;
//         const updatedFiles = {
//           ...files,
//           [nextFile.id]: nextFile,
//         };

//         uploadFiles(
//           {
//             files: updatedFiles,
//             uploadPath,
//             namePrefix,
//             dbProductId,
//           },
//           progressCallback,
//           finishCallback
//         );
//       }
//     );
//   } else {
//     // all files are uploaded
//     // send all file urls

//     // end recursive
//     if (finishCallback) {
//       finishCallback(files);
//     }
//   }
// }

function performUpload(
  { file, uploadPath, dbProductId },
  progressCallback,
  finishCallback
) {
  console.log("performUpload", file);
  const extension = file.name.split(".").pop();
  const fileName = `about_${Date.now()}.${extension}`;
  const metadata = {
    customMetadata: {
      aboutId: dbProductId,
    },
  };
  const bucketRef = firebase
    .storage()
    .ref()
    .child(uploadPath);
  const fileRef = bucketRef.child(fileName);
  let uploadTask = fileRef.put(file, metadata);

  uploadTask.on(
    firebase.storage.TaskEvent.STATE_CHANGED,
    (snapshot) => {
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

      console.log("Upload is " + progress + "% done");
      if (progressCallback) {
        progressCallback(progress);
      }

      switch (snapshot.state) {
        case firebase.storage.TaskState.PAUSED: // or 'paused'
          console.log("Upload is paused");
          break;
        case firebase.storage.TaskState.RUNNING: // or 'running'
          console.log("Upload is running");
          break;
      }
    },
    (error) => {
      console.log("error:", error);
      // A full list of error codes is available at
      // https://firebase.google.com/docs/storage/web/handle-errors
      switch (error.code) {
        case "storage/unauthorized":
          // User doesn't have permission to access the object
          break;

        case "storage/canceled":
          // User canceled the upload
          break;

        case "storage/unknown":
          // Unknown error occurred, inspect error.serverResponse
          break;
      }

      if (finishCallback) {
        console.log("finishCallback !!");
        finishCallback(null, error);
      }
    },
    () => {
      console.log("Upload completed successfully");
      // Upload completed successfully, now we can get the download URL
      if (finishCallback) {
        finishCallback({
          fileName,
          url: uploadTask.snapshot.downloadURL,
        });
      }
      // addFilePath(sessionId, file.name, fileRef.fullPath);
    }
  );
}



// WEBPACK FOOTER //
// ./src/actions/FirstSection.js